<template>
    <div>
        <h1>NotFound</h1>
    </div>
</template>

<script lang="ts" src="./NotFound.ts" />